




















































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import {
  SuketBaseWithRelationship,
  SuketKematianContentInterface
} from "@/types/suket_gawat_darurat";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import SuketKematian from "@/services/SuketKematian";
import StoreSuketKematian from "@/store/modules/SuketKematian";
import { storeDokter } from "@/store/modules/dokter";
import moment from "moment";
import AsesmenGadarMedisStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarMedisStore";
import AsesmenAwalRanapMedisStore from "@/store/modules/AsesmenAwalRanapMedisStore";
import ResumeRanapStore from "@/store/modules/ResumeRanapStore";

@Component({
  components: {
    CardModalTtd
  }
})
export default class SuketKematianInputCard extends Vue {
  @Prop() readonly register!: string;
  @Prop() dataSuket!: SuketBaseWithRelationship<SuketKematianContentInterface>;
  @Prop() readonly instantCreate: boolean;

  register_id = this.dataSuket?.register_id || this.register;
  pasien_rm = this.dataSuket?.pasien_rm || this.pasien.rm;
  unit_id = this.dataSuket?.unit_id || this.user.unit_id;
  nama = this.pasien.nama;
  umur =
    this.dataSuket?.pasien.umur ||
    getAge(formatDMYDate(this.pasien.tgl_lahir))
      .toString()
      .concat(" Th");
  jk = this.pasien.jk;
  alamat_type = this.dataSuket?.content.alamat_type || "ktp";
  death_at = this.dataSuket?.content.death_at
    ? moment(this.dataSuket.content.death_at).toDate()
    : null;
  surat_date = this.dataSuket?.surat_date || moment().format("YYYY-MM-DD");
  signee_user_id = this.dataSuket?.signee_user_id || this.user.id;
  creator_user_id = this.dataSuket?.creator_user_id || this.user.id;

  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id", max: moment().format("YYYY-MM-DD") };
  maxSuratDate = moment().format("YYYY-MM-DD");
  showSuratDatePicker = false;
  validasi = [v => !!v || "*Kolom ini harus diisi"];
  saving = false;

  mounted() {
    if (!this.death_at && userModule.user.unit_id == "01") {
      this.death_at = this.asesmenGadarMedis.content?.tindakLanjut
        .waktuMeninggal
        ? new Date(this.asesmenGadarMedis.content?.tindakLanjut.waktuMeninggal)
        : null;
    } else {
      this.death_at = this.resumeRanap?.waktu_meninggal
        ? new Date(this.resumeRanap.waktu_meninggal)
        : null;
    }

    if (!this.alamat_type) {
      this.alamat_type = "ktp";
    }
  }

  get resumeRanap() {
    return ResumeRanapStore.resume;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get alamatOptions() {
    const opts = [
      {
        id: "ktp",
        name: this.pasien.alamat,
        category: "Alamat KTP"
      }
    ];

    if (this.pasien.alamat_domisili) {
      opts.push({
        id: "domisili",
        name: this.pasien.alamat_domisili,
        category: "Alamat Domisili"
      });
    }

    return opts;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        alamat_type: this.alamat_type,
        death_at: this.death_at
          ? moment(this.death_at).format("YYYY-MM-DD HH:mm:ss")
          : null
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  get listDokter() {
    return storeDokter.list;
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  get asesmenGadarMedis() {
    return AsesmenGadarMedisStore.asesmen;
  }

  @Watch("instantCreate")
  changeInstantCreate(val) {
    if (val) {
      this.save();
    }
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const action = this.dataSuket
        ? SuketKematian.update(this.dataSuket.id, this.input)
        : SuketKematian.create(this.input);

      action
        .then(() => {
          if (this.canSign) {
            this.$emit("showSignatureModal");
          }

          appModule.NoticeDelay("Berhasil Simpan");

          this.close();
          StoreSuketKematian.getSuketByRegister(this.register);

          if (this.instantCreate) {
            this.close();
          }
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.$emit("close");
  }
}
